import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules, {
  init,
  queryMobilePackage,
  queryGoods,
  queryConfigDetail,
  disableConfig,
  initPage,
  open
} from './modules'
import Loading from 'components/Loading'
import { languageChange } from 'store/siteConfig'

export default function(route) {
  const Activate = Loadable({
    loader: () => import('./Activate'),
    render(loaded, props) {
      const Component = connect(
        (state) => ({
          topUpAutoRechargeActivateState: state.topUpAutoRechargeActivateState,
          siteConfig: state.siteConfig
        }),
        {
          init,
          languageChange,
          queryMobilePackage,
          queryGoods,
          queryConfigDetail,
          disableConfig,
          initPage,
          open
        }
      )(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path={`${route.match.path}/activate`}
      render={(routeProps) => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <Activate {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
